import { useEffect, useState } from 'react'
import { KeyCode } from '../constants/keyCodes'

const eventMatchesKey = (code: KeyCode, e: KeyboardEvent) => e.keyCode === code

export const useIsHoldingKey = (key: KeyCode) => {
  const [isHoldingKey, setIsHoldingKey] = useState(false)

  useEffect(() => {
    const handleDown = (e: KeyboardEvent) => {
      eventMatchesKey(key, e) && setIsHoldingKey(true)
    }

    const handleUp = (e: KeyboardEvent) => {
      eventMatchesKey(key, e) && setIsHoldingKey(false)
    }

    document.addEventListener('keydown', handleDown)
    document.addEventListener('keyup', handleUp)

    return () => {
      document.removeEventListener('keydown', handleDown)
      document.removeEventListener('keyup', handleUp)
    }
  }, [key])

  return isHoldingKey
}
